import { render, staticRenderFns } from "./finscrapcostshareview.vue?vue&type=template&id=663b84ae&scoped=true&"
import script from "./finscrapcostshareview.vue?vue&type=script&lang=js&"
export * from "./finscrapcostshareview.vue?vue&type=script&lang=js&"
import style0 from "./finscrapcostshareview.vue?vue&type=style&index=0&id=663b84ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663b84ae",
  null
  
)

export default component.exports